import {  TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoModule, TranslocoService, TRANSLOCO_TRANSPILER, TRANSLOCO_MISSING_HANDLER, TRANSLOCO_INTERCEPTOR, TRANSLOCO_FALLBACK_STRATEGY } from '@ngneat/transloco';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';
// import { Translation } from '@ngneat/transloco/lib/types';
import { TranslocoMessageFormatModule } from '@ngneat/transloco-messageformat';
import { environment } from 'environments/environment';

// Transloco Interceptor
class TranslocoInterceptor {
    preSaveTranslation(translation: any, lang: string) {
        return translation;
    }
}

// Transloco Fallback Strategy
class TranslocoFallbackStrategy {
    getNextLangs(failedLang: string): string[] {
        return [];
    }
}

@NgModule({
    imports: [
        TranslocoMessageFormatModule.forRoot()
    ],
    exports  : [
        TranslocoModule
    ],
    providers: [
        {
            // Provide the default Transloco configuration
            provide : TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs      : [
                    {
                        id   : 'es',
                        label: 'Español'
                    },
                    {
                        id   : 'ca',
                        label: 'Català'
                    }
                ],
                defaultLang         : 'es',
                fallbackLang        : 'es',
                reRenderOnLangChange: true,
                prodMode            : environment.production
            })
        },
        {
            // Provide the default Transloco loader
            provide : TRANSLOCO_LOADER,
            useClass: TranslocoHttpLoader
        },
        {
            // Provide handler for missing translations
            provide : TRANSLOCO_MISSING_HANDLER,
            useValue: {
                handle: (key: string) => {
                    console.warn(`Missing translation for key: ${key}`);
                    return key;
                }
            }
        },
        {
            // Provide default interceptor
            provide : TRANSLOCO_INTERCEPTOR,
            useClass: TranslocoInterceptor
        },
        {
            // Provide fallback strategy
            provide : TRANSLOCO_FALLBACK_STRATEGY,
            useClass: TranslocoFallbackStrategy
        },
        provideAppInitializer(() => {
        const initializerFn = ((translocoService: TranslocoService): any => (): Promise<any> => {
                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);
                return translocoService.load(defaultLang).toPromise();
            })(inject(TranslocoService));
        return initializerFn();
      }),/*{
            provide: TRANSLOCO_TRANSPILER, useClass: TranslocoMessageFormatModule
        }*/
    ]
})
export class TranslocoCoreModule
{
}
